import { Injectable } from '@angular/core';
import { NxDatepickerIntl } from '@aposin/ng-aquila/datefield';

@Injectable()
export class NxDateFieldIntlProvider extends NxDatepickerIntl {
  override calendarLabel = 'Kalendarz';
  override openCalendarLabel = 'Otwórz kalendarz';
  override prevMonthLabel = 'Poprzedni miesiąc';
  override nextMonthLabel = 'Następny miesiąc';
  override prevYearLabel = 'Poprzedni rok';
  override nextYearLabel = 'Następny rok';
  override prevMultiYearLabel = 'Poprzednie 20 lat';
  override nextMultiYearLabel = 'Następne 20 lat';
  override switchToMonthViewLabel = 'Wybierz datę';
  override switchToMultiYearViewLabel = 'Wybierz miesiąc i rok';

  // @TODO: Translate
  // constructor(translate: TranslateService) {
  //   translate
  //     .get('nx-datepicker')
  //     .pipe(first())
  //     .subscribe(
  //       (translations: {
  //         locale: string;
  //         calendarLabel: string;
  //         openCalendarLabel: string;
  //         prevMonthLabel: string;
  //         nextMonthLabel: string;
  //         prevYearLabel: string;
  //         nextYearLabel: string;
  //         prevMultiYearLabel: string;
  //         nextMultiYearLabel: string;
  //         switchToMonthViewLabel: string;
  //         switchToMultiYearViewLabel: string;
  //       }) => {
  //         this.calendarLabel = translations.calendarLabel;
  //         this.openCalendarLabel = translations.openCalendarLabel;
  //         this.prevMonthLabel = translations.prevMonthLabel;
  //         this.nextMonthLabel = translations.nextMonthLabel;
  //         this.prevYearLabel = translations.prevYearLabel;
  //         this.nextYearLabel = translations.nextYearLabel;
  //         this.prevMultiYearLabel = translations.prevMultiYearLabel;
  //         this.nextMultiYearLabel = translations.nextMultiYearLabel;
  //         this.switchToMonthViewLabel = translations.switchToMonthViewLabel;
  //         this.switchToMultiYearViewLabel = translations.switchToMultiYearViewLabel;
  //       },
  //     );
  //   super();
  // }
}
